import { FC } from 'react';
import { Section } from '../../../../components';
import {
	Form,
	FullLineLooker,
	Separator,
	TitleContainer
} from '../../Reports.styles';


const AdminDashboard: FC = () => {
	return (
		<>
			<Section>
				<TitleContainer>Dashboard</TitleContainer>
				<Separator />
				<Form>
					<FullLineLooker>
						<iframe
							title="Dashboard"
							width="100%"
							height="100%"
							src="https://lookerstudio.google.com/embed/reporting/ad6b3a7a-34d5-42cd-9738-88392b88ccd3/page/p_rh2miggxed"
							frameBorder="0"
							style={{ border: 0 }}
							allowFullScreen
							sandbox="allow-storage-access-by-user-activation allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox"
						></iframe>
					</FullLineLooker>
				</Form>
			</Section>
		</>
	);
};

export default AdminDashboard;
